<div class="stats-dashboard">
  <!-- =====================================================================
       KPI CARDS
       ===================================================================== -->
  <section class="stats-dashboard__kpis">
    <app-kpi-card
      [title]="'STATISTICS.DASHBOARD.KPIS.REVENUE' | translate"
      [value]="kpis?.revenue?.value || 0"
      [previousValue]="kpis?.revenue?.previousValue"
      [trend]="kpis?.revenue?.trend"
      format="currency"
      icon="pi-wallet"
      iconColor="primary"
      [loading]="loadingKpis"
    />

    <app-kpi-card
      [title]="'STATISTICS.DASHBOARD.KPIS.APPOINTMENTS' | translate"
      [value]="kpis?.appointments?.value || 0"
      [previousValue]="kpis?.appointments?.previousValue"
      [trend]="kpis?.appointments?.trend"
      format="number"
      icon="pi-calendar"
      iconColor="info"
      [loading]="loadingKpis"
    />

    <app-kpi-card
      [title]="'STATISTICS.DASHBOARD.KPIS.AVERAGE_TICKET' | translate"
      [value]="kpis?.averageTicket?.value || 0"
      [previousValue]="kpis?.averageTicket?.previousValue"
      [trend]="kpis?.averageTicket?.trend"
      format="currency"
      icon="pi-receipt"
      iconColor="success"
      [loading]="loadingKpis"
    />

    <app-kpi-card
      [title]="'STATISTICS.DASHBOARD.KPIS.NEW_PATIENTS' | translate"
      [value]="kpis?.newPatients?.value || 0"
      [previousValue]="kpis?.newPatients?.previousValue"
      [trend]="kpis?.newPatients?.trend"
      format="number"
      icon="pi-user-plus"
      iconColor="warning"
      [loading]="loadingKpis"
    />

    <app-kpi-card
      [title]="'STATISTICS.DASHBOARD.KPIS.CANCELLATIONS' | translate"
      [value]="kpis?.cancellationRate?.value || 0"
      [previousValue]="kpis?.cancellationRate?.previousValue"
      [trend]="kpis?.cancellationRate?.trend"
      format="percent"
      icon="pi-ban"
      iconColor="danger"
      [loading]="loadingKpis"
      [upIsGood]="false"
    />

    <app-kpi-card
      [title]="'STATISTICS.DASHBOARD.KPIS.OCCUPANCY' | translate"
      [value]="kpis?.occupancyRate?.value || 0"
      [previousValue]="kpis?.occupancyRate?.previousValue"
      [trend]="kpis?.occupancyRate?.trend"
      format="percent"
      icon="pi-clock"
      iconColor="info"
      [loading]="loadingKpis"
    />
  </section>

  <!-- =====================================================================
       MAIN CHART - REVENUE TIMELINE
       ===================================================================== -->
  <section class="stats-dashboard__main-chart">
    <div class="stats-dashboard__chart-card">
      <div class="stats-dashboard__chart-header">
        <h2 class="stats-dashboard__chart-title">
          <i class="pi pi-chart-line"></i>
          {{ "STATISTICS.DASHBOARD.CHARTS.REVENUE_EVOLUTION" | translate }}
        </h2>
      </div>
      <div class="stats-dashboard__chart-body">
        <app-stat-chart
          type="line"
          [data]="revenueChartData"
          [options]="revenueChartOptions"
          [loading]="loadingChart"
          [empty]="revenueTimeline.length === 0"
          height="280px"
        />
      </div>
    </div>
  </section>

  <!-- =====================================================================
       SECONDARY CONTENT
       ===================================================================== -->
  <section class="stats-dashboard__secondary">
    <!-- Top Treatments -->
    <app-top-list
      [title]="'STATISTICS.DASHBOARD.TOP_TREATMENTS.TITLE' | translate"
      icon="pi-heart"
      [items]="topTreatments"
      [loading]="loadingTreatments"
      [showTrend]="true"
      [maxItems]="5"
      emptyMessage="STATISTICS.DASHBOARD.TOP_TREATMENTS.EMPTY"
      (itemClick)="onTreatmentClick($event)"
      (seeAllClick)="seeAllTreatments()"
    />

    <!-- Top Patients -->
    <app-top-list
      [title]="'STATISTICS.DASHBOARD.TOP_PATIENTS.TITLE' | translate"
      icon="pi-users"
      [items]="topPatients"
      [loading]="loadingPatients"
      [showTrend]="false"
      [maxItems]="5"
      emptyMessage="STATISTICS.DASHBOARD.TOP_PATIENTS.EMPTY"
      (itemClick)="onPatientClick($event)"
      (seeAllClick)="seeAllPatients()"
    />
  </section>

  <!-- =====================================================================
       BOTTOM SECTION - PAYMENTS & INSIGHTS
       ===================================================================== -->
  <section class="stats-dashboard__bottom">
    <!-- Payment Methods Chart -->
    <div class="stats-dashboard__chart-card stats-dashboard__chart-card--small">
      <div class="stats-dashboard__chart-header">
        <h2 class="stats-dashboard__chart-title">
          <i class="pi pi-credit-card"></i>
          {{ "STATISTICS.DASHBOARD.CHARTS.PAYMENT_METHODS" | translate }}
        </h2>
      </div>
      <div class="stats-dashboard__chart-body">
        <app-stat-chart
          type="bar"
          [data]="paymentChartData"
          [options]="paymentChartOptions"
          [loading]="loadingPayments"
          [empty]="paymentMethods.length === 0"
          height="180px"
        />
      </div>
    </div>

    <!-- Insights Panel -->
    <div class="stats-dashboard__insights">
      <div class="stats-dashboard__insights-header">
        <h2 class="stats-dashboard__insights-title">
          <i class="pi pi-lightbulb"></i>
          {{ "STATISTICS.DASHBOARD.INSIGHTS.TITLE" | translate }}
        </h2>
      </div>
      <div class="stats-dashboard__insights-list">
        @for (insight of insights; track insight.message) {
          <div
            class="stats-dashboard__insight"
            [ngClass]="'stats-dashboard__insight--' + insight.type"
          >
            <i class="pi" [ngClass]="insight.icon"></i>
            <p>{{ insight.message }}</p>
          </div>
        }
        @if (loadingKpis) {
          <div
            class="stats-dashboard__insight stats-dashboard__insight--loading"
          >
            <div class="stats-dashboard__insight-skeleton"></div>
          </div>
          <div
            class="stats-dashboard__insight stats-dashboard__insight--loading"
          >
            <div class="stats-dashboard__insight-skeleton"></div>
          </div>
        }
      </div>
    </div>
  </section>
</div>
